(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["VarlaChristmas"]) return;
  try {
    
	(function($){
    	$.fn.snow = function(options){
        	var $flake = $('<div id="snowbox" />').css({'position':'absolute','z-index':'9999','top':'-50px'}).html('&#10052;'),
            	documentHeight = $(document).height(),
            	documentWidth = $(document).width(),
            	defaults = {
              		minSize: 10,
              		maxSize: 20,
              		newOn: 1000,
              		flakeColor: "#AFDAEF"
            	},
            	options = $.extend({},defaults,options);
          	var interval = setInterval(function(){
            var startPositionLeft = Math.random() * documentWidth - 100,
            	startOpacity = 0.5 + Math.random(),
            	sizeFlake = options.minSize + Math.random() * options.maxSize,
            	endPositionTop = documentHeight - 200,
            	endPositionLeft = startPositionLeft - 500 + Math.random() * 500,
            	durationFall = documentHeight * 10 + Math.random() * 5000;
            	$flake.clone().appendTo('body').css({
              		left: startPositionLeft,
              		opacity: startOpacity,
              		'font-size': sizeFlake,
              		color: options.flakeColor
            	}).animate({
              		top: endPositionTop,
              		left: endPositionLeft,
              		opacity: 0.2
            	},durationFall,'linear',function(){
              		$(this).remove();
            	});
          	},options.newOn);
        };
    })(jQuery);
    $(function(){
    	$.fn.snow({
        	minSize: 5,
          	maxSize: 50,
          	newOn: 300
        });
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculator-page"]) return;
  try {
    
	function result(){
		var num1 = parseFloat($(".miles-text").val());
		var num2 = parseFloat($(".week-text").val());
		var savedVal = num1 * 2 * num2 * 0.0352;
		var moneyVal = (num1 * 2 * num2 * 0.0352)*3.5;
		$(".saved-text").val(savedVal.toFixed(3));
		$(".money-text").val(moneyVal.toFixed(2));
    }
	function empty(){
		$(".saved-text").val(" ");
		$(".money-text").val(" ");
  	}
	$(".miles-text").keyup(function(){
		if($(".week-text").val() == "" || $(".miles-text").val() == ""){
			empty();
		}else{
			result();
		}
	});
	$(".week-text").keyup(function(){
		if($(".week-text").val() == "" || $(".miles-text").val() == ""){
			empty();
		}else{
			result();
		}
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eaglepro-product-template"]) return;
  try {
    
var slide = $(".anDown");
setInterval(function(){
   	if(!slide.hasClass("tranTop")){
   		slide.addClass("tranY");
      	slide.addClass("tranTop");
   	}else{
   		slide.removeClass("tranY");
      	slide.removeClass("tranTop");
   	}
},1000);
$(window).scroll(function(){
	var oTop = $(".product-single__description").offset().top;
	var sTop = 0;
	sTop = $(this).scrollTop();
	if(sTop >= oTop){
		$(".product-bottom-pay").css("bottom","0");
      	$(".supportBtn").css("bottom","95px");
	}else{
		$(".product-bottom-pay").css("bottom","-100%");
      	$(".supportBtn").css("bottom","10px");
	}
});


$(function(){
	$('body,html').animate({
    	scrollTop : 0
    }, 300);
    return false;
});
$(".varlaPay").show();
$("body").css("margin-bottom","55px");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["falcon-product-template"]) return;
  try {
    
var slide = $(".anDown");
setInterval(function(){
   	if(!slide.hasClass("tranTop")){
   		slide.addClass("tranY");
      	slide.addClass("tranTop");
   	}else{
   		slide.removeClass("tranY");
      	slide.removeClass("tranTop");
   	}
},1000);
$(window).scroll(function(){
	var oTop = $(".product-single__description").offset().top;
	var sTop = 0;
	sTop = $(this).scrollTop();
	if(sTop >= oTop){
		$(".product-bottom-pay").css("bottom","0");
      	$(".supportBtn").css("bottom","95px");
	}else{
		$(".product-bottom-pay").css("bottom","-100%");
      	$(".supportBtn").css("bottom","10px");
	}
});


$(function(){
	$('body,html').animate({
    	scrollTop : 0
    }, 300);
    return false;
});
$(".varlaPay").show();
$("body").css("margin-bottom","55px");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
	var slide = $(".anDown");
  	setInterval(function(){
    	if(!slide.hasClass("tranTop")){
      		slide.addClass("tranY");
        	slide.addClass("tranTop");
      	}else{
      		slide.removeClass("tranY");
        	slide.removeClass("tranTop");
      	}
  	},1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["img-list"]) return;
  try {
    
var $bigImg = `<div class="clickImg"><img src=""></div>`;
$("body").append($bigImg);
$(document).on('click','.imgPart img',function(){
	var _this = $(this),
        _src = _this.attr("src");
  	var Src = $(".clickImg img");
  	Src.attr("src",_src);
  	$(".clickImg").fadeIn();
});
$(document).on('click','.clickImg',function(){
	$(".clickImg").fadeOut();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-black-hero"] && !Shopify.designMode) return;
  try {
    
	var slide = $(".anDown");
  	setInterval(function(){
    	if(!slide.hasClass("tranTop")){
      		slide.addClass("tranY");
        	slide.addClass("tranTop");
      	}else{
      		slide.removeClass("tranY");
        	slide.removeClass("tranTop");
      	}
  	},1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pegasus-product-template"]) return;
  try {
    
$(window).scroll(function(){
	var oTop = $(".product-single__description").offset().top;
	var sTop = 0;
	sTop = $(this).scrollTop();
	if(sTop >= oTop){
		$(".product-bottom-pay").css("bottom","0");
      	$(".supportBtn").css("bottom","95px");
	}else{
		$(".product-bottom-pay").css("bottom","-100%");
      	$(".supportBtn").css("bottom","10px");
	}
});
$(".pegasusPay").show();
$("body").css("margin-bottom","55px");
$(".giftClick").click();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
var slide = $(".anDown");
setInterval(function(){
   	if(!slide.hasClass("tranTop")){
   		slide.addClass("tranY");
      	slide.addClass("tranTop");
   	}else{
   		slide.removeClass("tranY");
      	slide.removeClass("tranTop");
   	}
},1000);
$(window).scroll(function(){
	var oTop = $(".product-single__description").offset().top;
	var sTop = 0;
	sTop = $(this).scrollTop();
	if(sTop >= oTop){
		$(".product-bottom-pay").css("bottom","0");
      	$(".supportBtn").css("bottom","95px");
	}else{
		$(".product-bottom-pay").css("bottom","-100%");
      	$(".supportBtn").css("bottom","10px");
	}
});


$(function(){
	$('body,html').animate({
    	scrollTop : 0
    }, 300);
    return false;
});
$(".varlaPay").show();
$("body").css("margin-bottom","55px");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support_htm"]) return;
  try {
    
$(".content_info").on('click','.h1',function(){
	var _this = $(this);
  	if(!_this.hasClass("expanded")){
  		_this.addClass("expanded");
    	_this.next().stop(true).slideDown("fast");
  	}else{
  		_this.removeClass("expanded");
    	_this.next().stop(true).slideUp("fast");
  	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wasp-product-template"]) return;
  try {
    
var slide = $(".anDown");
setInterval(function(){
   	if(!slide.hasClass("tranTop")){
   		slide.addClass("tranY");
      	slide.addClass("tranTop");
   	}else{
   		slide.removeClass("tranY");
      	slide.removeClass("tranTop");
   	}
},1000);
$(window).scroll(function(){
	var oTop = $(".product-single__description").offset().top;
	var sTop = 0;
	sTop = $(this).scrollTop();
	if(sTop >= oTop){
		$(".product-bottom-pay").css("bottom","0");
      	$(".supportBtn").css("bottom","95px");
	}else{
		$(".product-bottom-pay").css("bottom","-100%");
      	$(".supportBtn").css("bottom","10px");
	}
});


$(function(){
	$('body,html').animate({
    	scrollTop : 0
    }, 300);
    return false;
});
$(".varlaPay").show();
$("body").css("margin-bottom","55px");

  } catch(e) { console.error(e); }
})();
})();
